import { makeAutoObservable, runInAction } from "mobx";
import { notificationService } from "services/notification.service";
import { Notification } from "types/notification.type";

class NotificationStore {
  notifications: Notification[] = [];
  loading = false;
  page = 1;
  currentPage = 1;
  limit = 5;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setNotifications(notifs: Notification[]) {
    this.notifications = notifs;
  }

  addNotification(notif: Notification) {
    this.notifications = [notif, ...this.notifications];
  }

  markAsRead(id: number) {
    const notif = this.notifications.find((n) => n.id === id);
    if (notif) notif.isRead = true;
  }

  get unreadCount() {
    return this.notifications.filter((n) => !n.isRead).length;
  }

  async fetchNotifications(companyId: number, page = 1) {
    this.loading = true;
    try {
      const res = await notificationService.getAll(companyId, page, this.limit);
      runInAction(() => {
        if (page === 1) {
          this.notifications = res.data;
        } else {
          this.notifications = [...this.notifications, ...res.data];
        }
        this.page = page;
      });
    } catch (err) {
      // console.error(err);
    } finally {
      runInAction(() => (this.loading = false));
    }
  }

  async markNotificationAsRead(id: number) {
    try {
      await notificationService.markAsRead(id);
      runInAction(() => {
        this.markAsRead(id);
      });
    } catch (err) {
      // console.error("Failed to mark notification as read", err);
    }
  }

  async markAllAsRead(companyId: number) {
    try {
      await notificationService.markAllAsRead(companyId);
      runInAction(() => {
        this.notifications.forEach((n) => (n.isRead = true));
      });
    } catch (err) {
      // console.error("Failed to mark all notifications as read", err);
    }
  }
}

const notificationStore = new NotificationStore();
export default notificationStore;
